module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"tab":{"article":"게시물 신고/차단","brand_user":"작성자 신고/차단"},"spam_type_label":"신고 사유 (필수)","reason_placeholder":"{max_length}자 이내로 신고 내용을 입력해주세요.","hint":"신고 항목에 포함되지 않는 내용은 기타를 선택하여 신고 내용을 작성해주시기 바랍니다.","hint2":"신고해주신 내용은 관리자 검토 후 내부정책에 의거 조치가 진행됩니다.","block_label":"차단 여부","block_message":{"article":"해당 게시물을 차단합니다.","brand_user":"해당 작성자의 게시물을 모두 차단합니다."}}}')
  delete Component.options._Ctor
}
